exports = module.exports = require("../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "$colreorder-insert-color:#0259c4 !default;// Floating table,dragged with the mouse table.DTCR_clonedTable{background-color:hsla(0,0%,100%,.7);z-index:202}// Insert line div.DTCR_pointer{width:1px;background-color:$colreorder-insert-color;z-index:201}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/datatables-colreorder/css/colReorder.dataTables.scss
// module id = 488
// module chunks = 0